import React from 'react';
import { useNavigate } from 'react-router-dom';

const PremiumMockExamCompletedModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  
  if (!isOpen) return null;

  const handleContinueTraining = () => {
    onClose();
    navigate('/study_plan');
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px 32px',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center',
        fontFamily: "'Manrope', sans-serif",
        position: 'relative',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>

        {/* Title */}
        <h2 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#111827',
          marginBottom: '12px',
          lineHeight: '1.3'
        }}>
          You've already completed this mock exam!
        </h2>

        {/* Description */}
        <p style={{
          fontSize: '14px',
          color: '#6B7280',
          lineHeight: '1.5',
          marginBottom: '24px'
        }}>
          For more, continue your personalized training.
        </p>

        {/* Button */}
        <div style={{
          display: 'flex',
          justifyContent: 'center'
        }}>
          <button
            onClick={handleContinueTraining}
            style={{
              padding: '12px 32px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: '#9333EA',
              color: 'white',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
              fontFamily: "'Manrope', sans-serif"
            }}
          >
            Continue Training
          </button>
        </div>
      </div>
    </div>
  );
};

export default PremiumMockExamCompletedModal;